// Top-level workout labels
export const WORKOUT_HEADER_SLOT = 'workout-header';
export const WORKOUT_NAME_SLOT = 'workout-name';
export const DATE_PICKER_SLOT = 'date-picker';

// Section labels
export const SECTION_NAME_SLOT = 'section-name';
export const ADD_SECTION_SLOT = 'add-section';

// Exercise labels
export const EXERCISE_NAME_SLOT = 'exercise-name';
export const ADD_SET_SLOT = 'add-set';
export const ADD_EXERCISE_SLOT = 'add-exercise';
